/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Sleep_PoorInputs */

const en_us2_workout_sleep_poor = /** @type {(inputs: Workout_Sleep_PoorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poor`)
};

const pt_br2_workout_sleep_poor = /** @type {(inputs: Workout_Sleep_PoorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ruim`)
};

const es_419_workout_sleep_poor = /** @type {(inputs: Workout_Sleep_PoorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Malo`)
};

const pt_pt2_workout_sleep_poor = /** @type {(inputs: Workout_Sleep_PoorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mau`)
};

const fr_fr2_workout_sleep_poor = /** @type {(inputs: Workout_Sleep_PoorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mauvais`)
};

const de_de2_workout_sleep_poor = /** @type {(inputs: Workout_Sleep_PoorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schlecht`)
};

const it_it2_workout_sleep_poor = /** @type {(inputs: Workout_Sleep_PoorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scarso`)
};

/**
* | output |
* | --- |
* | "Poor" |
*
* @param {Workout_Sleep_PoorInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_sleep_poor = /** @type {((inputs?: Workout_Sleep_PoorInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Sleep_PoorInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_sleep_poor(inputs)
	if (locale === "es-419") return es_419_workout_sleep_poor(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_sleep_poor(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_sleep_poor(inputs)
	if (locale === "de-DE") return de_de2_workout_sleep_poor(inputs)
	if (locale === "it-IT") return it_it2_workout_sleep_poor(inputs)
	return en_us2_workout_sleep_poor(inputs)
});
export { workout_sleep_poor as "workout.sleep_poor" }